import React from 'react';
import { useProductQuantity } from '../hooks/useProductQuantity';

type QuantitySelectorStepperProps = { children: React.ReactNode };

const QuantitySelectorStepper = ({ children }: QuantitySelectorStepperProps) => {
	const { blockClass } = useProductQuantity();

	const renderClass = () => blockClass && `vtex-product-quantity-1-x-quantitySelectorStepper--${blockClass}`;

	return (
		<div
			className={`quantitySelectorStepper quantitySelectorStepper--${blockClass} vtex-product-quantity-1-x-quantitySelectorStepper ${renderClass()}`}
		>
			{children}
		</div>
	);
};

export default QuantitySelectorStepper;
